import styles from './Buttons.module.scss'

export const PrimaryRegularButton = ({ children, className, ...props }) => (
  <button {...props} className={[styles.primaryButton, className].join(' ')}>
    {children}
  </button>
)

export const SecondaryRegularButton = ({ children, className, ...props }) => (
  <button {...props} className={[styles.secondaryButton, className].join(' ')}>
    {children}
  </button>
)
